import React from 'react';
import { Input } from './input';
import { cn } from '../../lib/utils';
import {
  DATETIME_MIN,
  DATETIME_MAX,
  sanitizeDateTimeValue,
} from '../../utils/dateValidation';

export default function DateTimeInput({
  value,
  onChange,
  error,
  className,
  id,
  required,
  disabled,
  min = DATETIME_MIN,
  max = DATETIME_MAX,
  ...props
}) {
  const handleChange = (e) => {
    const sanitized = sanitizeDateTimeValue(e.target.value);
    if (sanitized === null) return;
    onChange?.(sanitized);
  };

  return (
    <div className="space-y-1">
      <Input
        id={id}
        type="datetime-local"
        min={min}
        max={max}
        value={value ?? ''}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        className={cn(error && 'border-destructive focus-visible:ring-destructive', className)}
        aria-invalid={Boolean(error)}
        {...props}
      />
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
